/* WARP: 商品画像とカラー選択を双方向に同期する

   1) 表示中の画像のカラー名を、ギャラリー下に1行表示する
   2) スワイプ等で表示画像が変わったら、選択中のバリアントも同じ色に合わせる
      → 「見ている色」と「注文される色」がズレる事故を防ぐ

   設計メモ
   ・スライダーはSwiper。DOMの位置計測はトランジション中にズレるため使わず、
     Swiperインスタンスの activeIndex とその slide のaltを正とする。
   ・.swiper-slide-active はサムネイル側にも付くので使わない。
   ・slideChangeTransitionEnd は環境によって発火しないことがあるため、
     slideChange から遅延実行する方式にしている。
   ・カラーには仕上げ限定の色がある（例：ターコイズミストはつやなしのみ）。
     いまの仕上げのままでは選べない色にスワイプした場合は、
     仕上げも一緒に切り替える（→ 画像と選択が必ず一致する）。
   ・黒は1枚の画像を「マットブラック / グロスブラック」で共有しているため、
     altを「/」で分割し、いまの仕上げに存在する方を優先して採用する。
     つまり黒では仕上げは切り替わらない。キャプションも解決後の名前だけを出す。
   ・プルダウン変更 → 画像移動 → またプルダウン変更…のループを防ぐため、
     同期直後は一定時間だけ同期を止める（SUPPRESS_MS）。
*/
(function () {
  var CLS = 'warp-color-caption';
  var STYLE_ID = 'warp-color-caption-style';
  var SUPPRESS_MS = 1500;

  var suppressUntil = 0;
  var syncTimer = null;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.' + CLS + '{',
      '  display:block;width:100%;text-align:center;',
      '  font-size:1.3rem;line-height:1.5;letter-spacing:.04em;',
      '  color:rgb(var(--color-foreground));opacity:.8;',
      '  margin:1.0rem 0 0.4rem;padding:0;',
      '}',
      '.' + CLS + ':empty{display:none;}'
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }

  function jp(t) {
    t = (t || '').trim();
    if (!t) return '';
    return /[ぁ-んァ-ヶ一-龠]/.test(t) ? t : '';
  }

  function mainSwiper() {
    var el = document.querySelector('.product__media-list.swiper');
    return el && el.swiper ? el.swiper : null;
  }

  function variantSelects() {
    return document.querySelector('variant-selects');
  }

  /* 仕上げ / カラー の順で2つのselectがある想定。
     1つしかない商品ではカラーのみ返す。 */
  function finishSelect() {
    var vs = variantSelects();
    if (!vs) return null;
    var sels = vs.querySelectorAll('select');
    return sels.length > 1 ? sels[0] : null;
  }

  function colorSelect() {
    var vs = variantSelects();
    if (!vs) return null;
    var sels = vs.querySelectorAll('select');
    return sels.length > 1 ? sels[1] : (sels[0] || null);
  }

  /* テーマがvariant-selects内に埋めている全バリアントのJSON。
     v.options[0]=仕上げ, v.options[1]=カラー */
  function variantList() {
    var vs = variantSelects();
    if (!vs) return null;
    var s = vs.querySelector('script[type="application/json"]');
    if (!s) return null;
    try {
      var j = JSON.parse(s.textContent);
      return j && j.length ? j : null;
    } catch (e) { return null; }
  }

  function activeAlt() {
    var sw = mainSwiper();
    if (sw && sw.slides && sw.slides.length) {
      var slide = sw.slides[sw.activeIndex];
      var img = slide && slide.querySelector('img[alt]');
      if (img) return jp(img.getAttribute('alt'));
    }
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return '';
    var imgs = wrap.querySelectorAll('img[alt]');
    var cx = window.innerWidth / 2, best = null, bd = Infinity;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.width < 150) continue;
      var d = Math.abs((r.left + r.width / 2) - cx);
      if (d < bd) { bd = d; best = imgs[i]; }
    }
    return best ? jp(best.getAttribute('alt')) : '';
  }

  function altParts(alt) {
    return (alt || '').split('/').map(function (s) { return s.trim(); })
      .filter(function (s) { return !!s; });
  }

  /* いまのカラーselectに出ている選択肢の中から、altに合う色名を返す */
  function resolveOption(sel, alt) {
    if (!sel || !alt) return '';
    var names = Array.prototype.map.call(sel.options, function (o) { return o.value; });
    var parts = altParts(alt);
    for (var i = 0; i < parts.length; i++) {
      if (names.indexOf(parts[i]) !== -1) return parts[i];
    }
    return '';
  }

  /* altから「どの仕上げ・どの色にすべきか」を決める。
       { finish:'', color:'ターコイズミスト' }  → 仕上げはそのまま
       { finish:'つやなし', color:'ターコイズミスト' } → 仕上げも変える
     いまの仕上げで選べる色があれば必ずそちらを優先する（黒の共有画像対策）。 */
  function resolvePair(alt) {
    var col = colorSelect();
    if (!col || !alt) return null;
    var parts = altParts(alt);
    if (!parts.length) return null;

    var here = resolveOption(col, alt);
    if (here) return { finish: '', color: here };

    var fin = finishSelect();
    var variants = variantList();
    if (!fin || !variants) return null;

    for (var i = 0; i < parts.length; i++) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k];
        if (v && v.options && v.options.length > 1 && v.options[1] === parts[i]) {
          return { finish: v.options[0], color: parts[i] };
        }
      }
    }
    return null;
  }

  /* 表示用のラベル。解決できればその名前、
     できなければ「/」を含まないaltをそのまま出す */
  function displayLabel() {
    var alt = activeAlt();
    if (!alt) return '';
    var pair = resolvePair(alt);
    if (pair) return pair.color;
    return alt.indexOf('/') === -1 ? alt : '';
  }

  function updateCaption() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var el = wrap.querySelector(':scope > .' + CLS);
    if (!el) {
      el = document.createElement('p');
      el.className = CLS;
      wrap.appendChild(el);
    }
    var text = displayLabel();
    if (el.textContent !== text) el.textContent = text;
  }

  function syncSelect() {
    if (Date.now() < suppressUntil) return;
    var alt = activeAlt();
    if (!alt) return;
    var col = colorSelect();
    if (!col) return;
    var pair = resolvePair(alt);
    if (!pair) return;

    // (A) 仕上げはそのままでよい場合
    if (!pair.finish) {
      if (col.value === pair.color) return;
      suppressUntil = Date.now() + SUPPRESS_MS;
      col.value = pair.color;
      col.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // (B) いまの仕上げでは選べない色 → 仕上げも一緒に切り替える
    var fin = finishSelect();
    if (!fin) return;
    if (fin.value === pair.finish && col.value === pair.color) return;

    suppressUntil = Date.now() + SUPPRESS_MS;

    // 仕上げは値だけ変え、changeは出さない。
    // カラーの選択肢にはまだ目的の色が無いので一時的に足してから、
    // changeを1回だけ出す（再描画を1回で済ませ、ちらつきを防ぐ）。
    fin.value = pair.finish;

    var exists = Array.prototype.some.call(col.options, function (o) {
      return o.value === pair.color;
    });
    if (!exists) {
      var opt = document.createElement('option');
      opt.value = pair.color;
      opt.textContent = pair.color;
      col.appendChild(opt);
    }
    col.value = pair.color;
    col.dispatchEvent(new Event('change', { bubbles: true }));

    // 選択肢の作り直しは variant-hide-unavailable.js 側が担当するので、
    // ここではキャプションだけ追いかける。
    setTimeout(updateCaption, 500);
    setTimeout(updateCaption, 1300);
  }

  function onSlideChange() {
    updateCaption();
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncSelect();
      updateCaption();
    }, 420);
  }

  function bindSwiper() {
    var sw = mainSwiper();
    if (!sw) return false;
    if (sw.__warpBound) return true;
    sw.__warpBound = true;
    sw.on('slideChange', onSlideChange);
    sw.on('slideChangeTransitionEnd', onSlideChange);
    sw.on('touchEnd', function () { setTimeout(onSlideChange, 300); });
    return true;
  }

  function boot() {
    injectStyle();
    updateCaption();

    var tries = 0;
    var iv = setInterval(function () {
      if (bindSwiper() || ++tries > 25) clearInterval(iv);
    }, 300);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) {
        suppressUntil = Date.now() + SUPPRESS_MS;
        clearTimeout(syncTimer);
        setTimeout(updateCaption, 500);
        setTimeout(updateCaption, 1400);
      }
    }, true);

    setTimeout(updateCaption, 900);
    setTimeout(updateCaption, 2200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();